import fetch from '@/axios/promise';
import { BASIC } from '@/config/constant';

// 获取 角色、部门 信息 ，groupType 1:角色 2：部门 ，name： 名称 
export function getRoleDeptInfo(query) {
	return invoke(query, '/group/list', 'get')
};

function invoke(query, url, method) {
	return fetch({
		url: BASIC + url,
		method: method,
		params: query
	});
}


// WEBPACK FOOTER //
// ./src/api/base/base.js